
import { defineComponent, ref, provide } from 'vue'
import isMobile from 'ismobilejs'
import ModalBase from '@/components/common/ModalBase.vue'
import Btn from '@/components/common/Btn.vue'
import Title from '@/components/common/Title.vue'
import ProductItemListActivity from '@/components/ProductItemList_Activity.vue'
import store from '@/composition/store'
import request from '@/utils/request'
import {
  getActivity,
  getActivityList
} from '@/utils/requestUrl'
export default defineComponent({
  props: {
    portfolioName: {
      type: String,
      default: ''
    },
    modelValue: {
      type: String,
      require: false,
      default: ''
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ModalBase,
    Btn,
    Title,
    ProductItemListActivity
  },
  setup (props, context) {
    const { emit } = context
    const change = (event: Event) => {
      emit('update:modelValue', (event.target as HTMLInputElement).value)

      console.log(props.modelValue)
      console.log((event.target as HTMLInputElement).value)
      console.log(typeof (event.target as HTMLInputElement).value)
    }
    const title = ref('')
    const content = ref('')
    const activityData = ref(null)
    const modalElement = ref(null)
    provide('store', store)

    const promiseResolver = ref(
      (value?: any | PromiseLike<Record<string, never>> | undefined) => {
        return null
      }
    )
    const promiseReject = ref(
      (value?: any | PromiseLike<Record<string, never>> | undefined) => {
        return null
      }
    )
    const hideCancel = ref(true)
    const cancel = () => {
      /**
       * 取消按鈕通知
       * @event cancel
       * @type {none}
       */
      // this.$emit('cancel');
      promiseReject.value()
      emit('update:show', false)
    }
    const confirm = () => {
      /**
       * 確認按鈕通知
       * @event confirm
       * @type {none}
       */
      // this.$emit('confirm');
      promiseResolver.value()
      emit('update:show', false)
    }
    const createConfirm = async (
      activityID: string,
      callback: (modalElement: any) => void
    ) => {
      store.setShowLoading(true)
      const res = await request.post(window._env_.VUE_APP_STOREBOOK_SERVICE_API + getActivity, {
        Data: {
          ShopCode: 'G-Gift',
          PromotionActivityId: activityID
        }
      })

      activityData.value = res.data.Data
      emit('update:show', true)

      store.setShowLoading(false)

      callback(modalElement)
      return new Promise((resolve: any, reject: any) => {
        promiseResolver.value = resolve
        promiseReject.value = reject
      })
    }
    return {
      title,
      content,
      hideCancel,
      activityData,
      change,
      cancel,
      confirm,
      createConfirm,
      isMobile,
      modalElement
    }
  }
})
